import type { TypeGetDeliveryTypeParams } from '~/types/delivery-agency.types';

/**
 * [배송 권역] React Query Key Factory
 */
export const deliveryAreaKeys = {
  all: ['delivery-area'] as const,

  /** 화주사 배송 권역 조회 */
  deliveryType: (vendor: string, params: TypeGetDeliveryTypeParams) =>
    [...deliveryAreaKeys.all, 'deliveryType', vendor, params] as const,
};
